import { AfterContentInit, contentChildren, Directive, inject, OnDestroy } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { IsActiveMatchOptions, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RouterTabDirective } from './router-tab.directive';

@Directive({
	selector: '[routerTabs]',
	standalone: true,
})
export class RouterTabsDirective implements AfterContentInit, OnDestroy {
	private host = inject(MatTabGroup);
	private router = inject(Router);

	subscriptions = new Subscription();


	public routerTabs = contentChildren(RouterTabDirective);


	constructor() {
	}


	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}


	ngAfterContentInit(): void {

		this.activateTheTabThatMatchesTheRoute();

		this.subscriptions.add(this.router.events.subscribe((e) => {
			if (e instanceof NavigationEnd) {
				setTimeout(this.activateTheTabThatMatchesTheRoute.bind(this));
			}
		}));

		this.subscriptions.add(this.host.selectedTabChange.subscribe(() => {
			const tab = this.routerTabs().find(item => item.tab.isActive);
			if (!tab) return false;

			if (tab.link.urlTree) {
				this.router.navigateByUrl(tab.link.urlTree);
			}
			return true;
		}));
	}


	private activateTheTabThatMatchesTheRoute() {

		this.routerTabs().find((tab, i) => {

			const options: IsActiveMatchOptions = { paths: 'subset', queryParams: 'subset', fragment: 'ignored', matrixParams: 'ignored' };
			if (!tab.link.urlTree || !this.router.isActive(tab.link.urlTree, options)) return false;

			tab.tab.isActive = true;
			this.host.selectedIndex = i;
			return true;
		});
	}
}